export const settings = {
  // Page header
  title: 'Settings',
  subtitle: 'System settings and configuration',
  
  // Tabs
  tabs: {
    organizations: {
      name: 'Organizations',
      description: 'Manage organizations'
    },
    users: {
      name: 'Users',
      description: 'User management'
    },
    notifications: {
      name: 'Notifications',
      description: 'Notification settings'
    },
    aiSettings: {
      name: 'AI Settings',
      description: 'Claude AI integration'
    },
    emailSettings: {
      name: 'Email / SMTP',
      description: 'Email settings'
    },
    emailTemplates: {
      name: 'Email Templates',
      description: 'Email templates'
    },
    billing: {
      name: 'Billing',
      description: 'Billing settings'
    },
    categories: {
      name: 'Categories',
      description: 'Product categories'
    },
    customFields: {
      name: 'Custom Fields',
      description: 'Manage custom fields'
    },
    mfaPolicy: {
      name: 'MFA Policy',
      description: 'System-wide MFA enforcement'
    }
  },
  
  // Sidebar groups
  sidebar: {
    groups: {
      organization: 'Organization',
      communication: 'Communication',
      system: 'System',
      security: 'Security'
    },
    search: 'Search settings...'
  },
  
  categories: {
    title: 'Categories',
    subtitle: 'Manage and organize categories',
    add: 'Add Category',
    noCategories: 'No categories',
    noCategoriesTooltip: 'Start by adding a product category',
    fields: {
      name: 'Name',
      productCount: 'Products',
      actions: 'Actions'
    },
    messages: {
      confirmTitle: 'Delete Category',
      deleteQuestion: 'Are you sure you want to delete this category?',
      deleteWarning: 'This action cannot be undone and will remove all product associations.',
      dangerousDeleteWarning: '⚠️ WARNING! This category contains products! Deleting it may affect these products. This action cannot be undone.'
    },
    form: {
      add: 'Add Category',
      edit: 'Edit Category',
      addDetails: 'Category Details',
      editDetails: 'Edit Category Details',
      name: 'Name',
      parent: 'Parent Category',
      noParent: 'No parent (Main category)',
      status: 'Status',
      active: 'Active',
      nameRequired: 'Name is required',
      update: 'Update Category',
      create: 'Create Category'
    }
  },
  
  notifications: {
    title: 'Notification Settings',
    subtitle: 'Customize and manage your notification preferences',
    
    // Email notifications
    emailNotifications: 'Email Notifications',
    emailDescription: 'Choose which events you want to receive email notifications for',
    
    // In-app notifications
    inAppNotifications: 'In-App Notifications',
    inAppDescription: 'Configure which notifications appear in the application',
    
    // Other settings
    otherSettings: 'Other Settings',
    otherDescription: 'Sound, desktop notifications and other settings',
    
    // Sound settings
    soundEnabled: 'Enable Sound',
    soundEnabledDesc: 'Play sound when new notifications arrive',
    
    // Desktop notifications
    desktopNotifications: 'Desktop Notifications',
    desktopNotificationsDesc: 'Show system notifications in the browser',
    
    // Debug mode
    debugMode: 'Debug Mode',
    debugModeDesc: 'Also send notifications to yourself (for testing purposes)',
    
    // Quiet hours
    quietHours: 'Quiet Hours',
    quietHoursDesc: 'Set a time interval when you don\'t want to receive notifications',
    enableQuietHours: 'Enable Quiet Hours',
    startTime: 'Start Time',
    endTime: 'End Time',
    
    // Descriptions for notification types
    taskAssignedDesc: 'Get notified when a new task is assigned to you',
    taskCompletedDesc: 'Get notified when a task is completed',
    taskOverdueDesc: 'Get notified when a task becomes overdue',
    projectUpdateDesc: 'Get notified about project updates',
    deadlineReminderDesc: 'Reminders about upcoming deadlines',
    systemDesc: 'System-level notifications and announcements',
    
    // Messages
    saveSuccess: 'Settings saved successfully',
    saveError: 'Error occurred while saving settings',
    loadError: 'Error occurred while loading settings'
  },
  
  // Organizations
  organizations: {
    title: 'Organizations',
    subtitle: 'Manage organization data',
    selectOrg: 'Select organization',
    noOrg: 'No organization selected',
    editOrg: 'Edit organization'
  },
  
  // Users
  users: {
    title: 'Users',
    subtitle: 'Manage users and permissions',
    addUser: 'Add user',
    inviteUser: 'Invite user',
    noUsers: 'No users'
  },
  
  // AI Settings
  aiSettings: {
    title: 'AI Settings',
    subtitle: 'Configure Claude AI integration',
    apiKey: 'API Key',
    model: 'Model',
    enabled: 'Enable AI features'
  },
  
  // Email Settings
  emailSettings: {
    title: 'Email / SMTP Settings',
    subtitle: 'Configure email sending',
    smtpHost: 'SMTP Server',
    smtpPort: 'Port',
    smtpUser: 'Username',
    smtpPassword: 'Password',
    fromEmail: 'From email',
    fromName: 'From name',
    testConnection: 'Test connection'
  },
  
  // Email Templates
  emailTemplates: {
    title: 'Email Templates',
    subtitle: 'Manage email templates',
    addTemplate: 'Add template',
    editTemplate: 'Edit template',
    noTemplates: 'No templates'
  },
  
  // Billing
  billing: {
    title: 'Billing Settings',
    subtitle: 'Configure billing system',
    agentKey: 'Számlázz.hu Agent Key',
    companyInfo: 'Company information',
    bankAccount: 'Bank account',
    taxNumber: 'Tax number'
  },
  
  // Common
  common: {
    save: 'Save',
    cancel: 'Cancel',
    edit: 'Edit',
    delete: 'Delete',
    add: 'Add',
    loading: 'Loading...',
    saved: 'Saved',
    error: 'Error occurred'
  }
}